// extracted by mini-css-extract-plugin
export var active = "langsSection-module--active--39906";
export var button = "langsSection-module--button--134b1";
export var mainWrapper = "langsSection-module--mainWrapper--31d29";